import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";

const deleteAgentApiImpl = async (agentId: string): Promise<Either<ErrorEntity, void>> =>{
    try {
        const relativeUrl = `/agent/${agentId}`;
        const response = await di.get<HostApi>(HostApiName).remove(relativeUrl);
        return right(undefined);
    } catch (error) {
        return left(ErrorEntity.fromError(error));
    }
}

export default deleteAgentApiImpl;